import { Box, useRadio } from '@chakra-ui/react';

export interface OptionComponentProps {
  props;
}

export const OptionComponent = props => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as='label' w={{ base: '48%', md: 'auto' }} flexShrink={0}>
      <input {...input} />
      <Box
        {...checkbox}
        cursor='pointer'
        px={6}
        py={2}
        fontSize='small'
        border='1px solid'
        borderColor='gray.400'
        borderRadius='0'
        minW={{ base: '100%', md: 'auto' }}
        textAlign='center'
        whiteSpace='nowrap'
        _first={{
          borderTopLeftRadius: 'sm',
          borderBottomLeftRadius: 'sm',
        }}
        _last={{
          borderTopRightRadius: 'sm',
          borderBottomRightRadius: 'sm',
          borderRight: '1px solid',
        }}
        _checked={{
          bg: 'brand.500',
          color: 'white',
          borderColor: 'brand.500',
        }}
        _notLast={{
          borderRight: 'none',
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
};

export default OptionComponent;
